<template>
    <div>
        <div :value="value">
            <progress :value="value" max="100" style="width: 100%"></progress>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BProgressStudy",
        props: {
            value: Number,
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>

    progress[value] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        height: 10px;
        border-radius: 5px;
        border: none;
    }

    progress[value]::-webkit-progress-bar {
        background: #E7E7E7;
        border-radius: 5px;
    }

    progress[value]::-webkit-progress-value {
        background-image: linear-gradient(90deg, #56E5FE 0%, #9991DE 100%);
        background-size: 100% 10px, 100% 100%, 100% 100%;
        border-radius: 5px;
    }

    progress[value]::-moz-progress-bar {
        background: #E7E7E7;
        border-radius: 5px;
        background-image: linear-gradient(90deg, #56E5FE 0%, #9991DE 100%);
        background-size: 100% 10px, 100% 100%, 100% 100%;
    }

</style>